export default __webpack_public_path__ + "static/media/Clothing.2e4f5da6.png";